import router from '@/router'
import store from '@/store'

const IDLE_LIMIT_MS = 30 * 60 * 1000
const CHECK_INTERVAL_MS = 60 * 1000
const EXAM_ROUTE_NAMES = ['ExamTaking', 'PracticeTaking']

let lastActiveTime = Date.now()
let timer = null

function markActive() {
  lastActiveTime = Date.now()
}

function isExamPage() {
  return EXAM_ROUTE_NAMES.indexOf(router.currentRoute.name) !== -1
}

function logoutByIdle() {
  store.dispatch('logout')
  router.push('/login').catch(() => {})
}

export function startIdleWatch() {
  if (timer) {
    return
  }
  const events = ['mousemove', 'mousedown', 'keydown', 'scroll']
  events.forEach(evt => window.addEventListener(evt, markActive, { passive: true }))
  lastActiveTime = Date.now()
  timer = setInterval(() => {
    if (!store.getters.token || isExamPage()) {
      lastActiveTime = Date.now()
      return
    }
    if (Date.now() - lastActiveTime > IDLE_LIMIT_MS) {
      stopIdleWatch()
      logoutByIdle()
    }
  }, CHECK_INTERVAL_MS)
}

export function stopIdleWatch() {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
  const events = ['mousemove', 'mousedown', 'keydown', 'scroll']
  events.forEach(evt => window.removeEventListener(evt, markActive))
}